import { SharedFieldsService } from "../fields/service"
import { OmniaModuleId } from "../generated/enums"
import { IHolding } from "../holding"
import { OmniaService } from "../service"
import { IOmniaSession } from "../types"
import { RoleId } from "../user"
import { pad2 } from "../utils/utils"
import { HoldingEditModel, HoldingEditStatus, IHoldingService } from "./types"

/** @internal */
export class HoldingService extends OmniaService implements IHoldingService {


    static $inject = ["OmniaSession", "OmniaFieldsService"]

    constructor(session: IOmniaSession, private fields: SharedFieldsService) {

        super(session, {
            name: "Holding",
            module: OmniaModuleId.Holding,
            dependencies: [fields]
        })

    }

    protected getRefreshPromise() {
        return undefined
    }

    getStatus(holdingId: number) {
        const { yearId } = this.session
        const url = `/api/holdings/v1/status?holdingId=${holdingId ?? 0}&year=${yearId ?? 0}`
        return this.ohttp.get<HoldingEditStatus>(url).then(r => r.data)
    }

    saveHolding(model: HoldingEditModel): ng.IPromise<IHolding> {

        const { ohttp, session: { yearId: year, currentUserRole: currentRole } } = this
        const { holding, ...data } = model

        const isNew = !holding.HoldingId

        const payload = {
            ...data,
            holding: {
                ...holding,
                AgronomistId: (currentRole <= RoleId.Agronomist ? this.session.currentUser.Id : null),
                town: undefined
            },
            croppingYearId: year,
        }

        const url = "/api/holdings/v1"

        const p = isNew
            ? ohttp.put(url, payload)
            : ohttp.post(url, payload)

        return p.then(r => r.data)

    }

    isHoldingEmpty(holdingId: number): ng.IPromise<any> {
        const url = "/api/dashboard/holding/empty/" + holdingId
        return this.ohttp.get(url);
    }

    deleteHolding(holdingId: number): ng.IPromise<any> {
        const url = "/api/dashboard/holding/delete/" + holdingId;
        return this.ohttp.post(url).then(r => r.data);
    }

    exportHolding(holding: IHolding): ng.IPromise<any> {

        const date = new Date(Date.now());

        const fileName = holding.TradingName + "-" + date.getFullYear() + pad2(1 + date.getMonth()) + date.getDate() + ".zip";

        const url = "/api/export/omnia/holding/" + holding.HoldingId;

        return this.ohttp.postAndDownload(url, fileName, null);
    }


    getFieldsArea() {
        return this.fields.getFieldsArea()
    }

}
